import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { brl } from "@/lib/format";
import { PageHeader, Panel, TableShell } from "@/components/admin/ui";

export default function FinancialPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/financial").then((r) => setData(r.data)).catch(() => setData({ receivables: [], payables: [] }));
  }, []);

  if (!data) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 size={28} className="animate-spin text-[#FFB800]" />
      </div>
    );
  }

  const totalIn = data.receivables.reduce((a, r) => a + r.value, 0);
  const totalOut = data.payables.reduce((a, p) => a + p.value, 0);

  return (
    <div data-testid="financial-page">
      <PageHeader title="Financeiro" sub="Contas a receber e contas a pagar" testId="financial-header" />
      <div className="grid gap-5 xl:grid-cols-2">
        <Panel title={`Contas a Receber — ${brl(totalIn)}`} testId="financial-receivables-panel">
          <TableShell head={["Cliente", "Serviço", "Valor", "Vencimento"]} testId="receivables-table">
            {data.receivables.map((r, i) => (
              <tr key={r.id} className="text-zinc-300" data-testid={`fin-receivable-row-${i}`}>
                <td className="px-5 py-4 font-semibold text-white">{r.client}</td>
                <td className="px-5 py-4">{r.service}</td>
                <td className="px-5 py-4 font-semibold text-emerald-400">{brl(r.value)}</td>
                <td className="px-5 py-4 text-zinc-500">{r.due}</td>
              </tr>
            ))}
          </TableShell>
        </Panel>
        <Panel title={`Contas a Pagar — ${brl(totalOut)}`} testId="financial-payables-panel">
          <TableShell head={["Fornecedor", "Descrição", "Valor", "Vencimento"]} testId="payables-table">
            {data.payables.map((p, i) => (
              <tr key={p.id} className="text-zinc-300" data-testid={`fin-payable-row-${i}`}>
                <td className="px-5 py-4 font-semibold text-white">{p.supplier}</td>
                <td className="px-5 py-4">{p.description}</td>
                <td className="px-5 py-4 font-semibold text-red-400">{brl(p.value)}</td>
                <td className="px-5 py-4 text-zinc-500">{p.due}</td>
              </tr>
            ))}
          </TableShell>
        </Panel>
      </div>
    </div>
  );
}
